<template>
  <div>
    <div class="knowledge">
      <div class="knowledge-svg">
        <template v-if="infor.list.length && level === 1">
          <!-- 填充+ -->
          <svg
            v-if="!isOpen"
            class="svg-icon1"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <rect width="16" height="16" opacity="0" />
            <g transform="translate(2 2)">
              <rect
                width="12"
                height="12"
                rx="6"
                fill="#e60003"
                stroke="#e60003"
                stroke-width="1.8"
              />
              <path
                d="M26.182,952.456h6.085"
                transform="translate(-23.225 -946.456)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-width="1.8"
              />
              <path
                d="M0,0H6.086"
                transform="translate(6 2.957) rotate(90)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-width="1.8"
              />
            </g>
          </svg>

          <!-- 填充- -->
          <svg
            v-else
            class="svg-icon2"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <rect width="16" height="16" opacity="0" />
            <g transform="translate(2 2)">
              <rect
                width="12"
                height="12"
                rx="6"
                fill="#e60003"
                stroke="#e60003"
                stroke-width="1.8"
              />
              <path
                d="M26.182,952.456h6.085"
                transform="translate(-23.225 -946.456)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-width="1.8"
              />
            </g>
          </svg>
        </template>
        <template v-else-if="infor.list.length">
          <!-- 描边+ -->
          <svg
            v-if="!isOpen"
            class="svg-icon3"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <rect width="16" height="16" opacity="0" />
            <g transform="translate(2 2)">
              <rect width="12" height="12" rx="6" fill="none" stroke="#e60003" stroke-width="1.8" />
              <path
                d="M26.182,952.456h4.994"
                transform="translate(-22.679 -946.456)"
                fill="none"
                stroke="#e60003"
                stroke-linecap="round"
                stroke-width="1.8"
              />
              <path
                d="M26.182,952.456h4.994"
                transform="translate(958.456 -22.679) rotate(90)"
                fill="none"
                stroke="#e60003"
                stroke-linecap="round"
                stroke-width="1.8"
              />
            </g>
          </svg>

          <!-- 描边- -->
          <svg
            v-else
            class="svg-icon4"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <rect width="16" height="16" opacity="0" />
            <g transform="translate(2 2)">
              <rect width="12" height="12" rx="6" fill="none" stroke="#e60003" stroke-width="1.8" />
              <path
                d="M26.182,952.456h4.994"
                transform="translate(-22.679 -946.456)"
                fill="none"
                stroke="#e60003"
                stroke-linecap="round"
                stroke-width="1.8"
              />
            </g>
          </svg>
        </template>
      </div>
      <div class="knowledge-content">
        <p class="title">{{ infor.name }}</p>
        <p class="content">
          <span class="text">共{{ infor.total_num }}题</span>
          <span class="text">答对{{ infor.correct_num }}题</span>
          <span class="text">正确率{{ infor.percentage }}%</span>
          <span class="text">用时{{ secondText(infor.total_t) }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    level: Number,
    infor: Object,
    isOpen: Boolean,
  },
  computed: {
    secondText() {
      return function (number) {
        let second = number % 60
        let minute = (number - second) / 60
        second = this.$util.formatSingleNumber(second) + '″'
        minute = this.$util.formatSingleNumber(minute) + '′'

        return minute + second
      }
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.knowledge {
  display: flex;

  .svg-icon1 {
    rect {
      fill: var(--main-color);
      stroke: var(--main-color);
    }
  }

  .svg-icon2 {
    g rect {
      fill: var(--main-color);
      stroke: var(--main-color);
    }
  }

  .svg-icon3 {
    g path,
    g rect {
      stroke: var(--main-color);
    }
  }

  .svg-icon4 {
    g path,
    g rect {
      stroke: var(--main-color);
    }
  }

  &-svg {
    width: 0.75rem;
    padding-top: 0.51rem;

    svg {
      // width: .43rem;
      // height: .43rem;
    }
  }

  &-content {
    flex: 1;
    // border-bottom: 1px solid #EBECF0;
    padding-top: 0.45rem;
    padding-bottom: 0.45rem;

    .title {
      font-size: 0.4rem;
      font-weight: 400;
      line-height: 0.64rem;
      color: #22242e;
      margin-bottom: 0.1rem;
    }

    .content {
      line-height: 0;

      .text {
        display: inline-block;
        font-size: 0.29rem;
        line-height: 1;
        color: #919499;
        padding: 0 0.2rem;

        &:nth-child(1) {
          padding-left: 0;
        }

        &:nth-child(n + 2) {
          border-left: 1px solid #ebecf0;
        }
      }
    }
  }
}
</style>
